import store from '@/store/index'

/**
 * 获取直播播放地址
 * 公有云：直接返回
 * 私有化：拼接hwmsplay代理地址 http://192.168.3.121:15001/live/xxx.flv -> https://hostname/hwmsplay/192.168.3.121:15001/live/xxx.flv
 * @param {*} liveUrl 获取到的直播地址
 * @returns
 */
export function getLiveUrl(liveUrl) {
  console.log(`liveUrl before:${liveUrl}`)
  // 私有化使用的地址可能是非法https证书，默认无法访问，所以需要进行代理
  if (!store.getters.isCloud) {
    let urlList = liveUrl.split('//')
    if (location.hostname !== 'localhost') {
      // 线上环境使用  代理地址：
      let port = ['80', '443', ''].includes(location.port) ? '' : ':' + location.port
      // 默认端口不需要拼接
      liveUrl = location.protocol + '//' + location.hostname + port + '/hwmsplay/' + urlList[1]
    } else {
      // 本地私有化开发 使用 私有化测试环境代理地址
      liveUrl = 'https://intranet.iot.huaweisoft.com/hwmsplay/' + urlList[1]
    }
  } else {
    // 公有云快直播使用webrtc模式进行播放
    if (store.getters.isQuickLive) {
      liveUrl = liveUrl.replace('https', 'webrtc').replace('.flv', '')
    }
  }
  console.log(`liveUrl after:${liveUrl}`)
  return liveUrl
}
